import React, { useEffect, useState } from 'react'
import { expertsDataBasedOnSubject } from '../../utilities/constants'
import useWindowSize from '../../hooks/useWindowSize'

const CocreatedBy = ({ skillName }) => {

    const [ expertsData, setExpertsData ] = useState([])

    const { width } = useWindowSize()

    useEffect(() => {
        if (expertsDataBasedOnSubject[skillName]){
            setExpertsData(expertsDataBasedOnSubject[skillName])
        }else{
            setExpertsData(expertsDataBasedOnSubject['Others'])
        }
    },[skillName])

    return (
        <div className={`flex justify-center ${width <= 360 ? 'gap-4' : 'gap-8'} items-center text-white mt-2`}>
            <div>
                <p className='text-xxs text-white/50 font-medium'>Co-Created By</p>
                <p className='text-sm font-medium'>{'Vibhu Mittal'}</p>
            </div>
            <div className='flex gap-2 items-center mt-1'>
                <img src={'https://assets.learntube.ai/files/Global/image%20820.png?updatedAt=1743489824801'} width={40} height={40} alt="" className='w-10 h-10 rounded-full object-cover'/>
                <div>
                    <p className='text-[12px] mb-0.5'>{'CTO'}</p>
                    <div className='flex flex-row justify-center items-center gap-2'>
                        <img src={'https://assets.learntube.ai/files/Global/image%20821.png?updatedAt=1743256763317'} width={20} height={20} alt="" />
                        <div className='text-[12px] text-white/50'>Inflection AI</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CocreatedBy